<template>
  <div :class="['header-content', isLarge ? 'is-large' : 'is-not-large']">
    <div class="header-content-exit" v-if="token">
      <h1>
        <img :src="require('@/assets/login/header.png')" alt="帕拉卡" />
        <span>帕拉卡数据平台</span>
      </h1>
      <div class="header-content-exit-right">
        <div title="代理人平台使用手册" @click="onHelp">
          <span>使用帮助</span>
          <i class="icon iconfont icon-help use-help"></i>
        </div>
        <div @click="loginBox('edit')">退出登录</div>
      </div>
    </div>
    <div class="header-content-login" v-else>
      <h1>帕拉卡数据平台</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Header',
  computed: {
    ...mapGetters({
      token: 'customer/token',
      isLarge: 'customer/isLarge'
    })
  },
  methods: {
    ...mapActions({
      logout: 'customer/logout'
    }),
    onHelp() {
      window.open('https://keepwork.com/dominuz/daili/index')
    },
    loginBox() {
      // 退出弹窗
      this.$confirm('您确定要退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'loginOut'
      })
        .then(async () => {
          await this.logout()
          this.$router.push({
            name: 'Login'
          })
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出'
          })
        })
    }
  }
}
</script>

<style lang="scss">
.is-large {
  width: 1920px;
}
.is-not-large {
  width: 1280px;
}
.header-content {
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-content-exit {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h1 {
      width: 18%;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          rgba(46, 55, 64, 0.99) 0%,
          rgba(58, 73, 88, 0.99) 100%
        ),
        linear-gradient(#1890ff, #1890ff);
      font-size: 18px;
      font-weight: SourceHanSansCN-Regular;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 12px;
      }
    }
    .header-content-exit-right {
      display: flex;
      div {
        margin-right: 30px;
        font-size: 14px;
        cursor: pointer;
        padding: 4px;
      }
      span {
        color: #909399;
      }
      div:hover {
        color: #3dc7f8;
        span {
          color: #3dc7f8;
        }
      }
      .use-help {
        margin-left: 4px;
        font-size: 12px;
        color: #3dc7f8;
      }
    }
    img {
      width: 66px;
    }
  }
  .header-content-login {
    width: 1200px;
    margin: 0 auto;
    h1 {
      font-weight: SourceHanSansCN-Regular;
      font-size: 18px;
      color: #333333;
    }
  }
}
body {
  .loginOut {
    height: 180px;
    .el-message-box__content {
      height: 60px;
      .el-message-box__container {
        line-height: 60px;
      }
    }
  }
}
</style>
